<template>
  <div v-if="preQualification">
    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'generatorUserId' + index">Generator</label>
      </b-col>
      <b-col md="8">
        <b-form-select :id="'generatorUserId' + index"
                       :options="lookups.generators"
                       v-model="preQualification.generatorUserId"
                       value-field="id"
                       text-field="fullName">
          <template v-slot:first>
            <b-form-select-option :value="null">-</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'clientName' + index">Client Name</label>
      </b-col>
      <b-col md="8">
        <b-form-input :id="'clientName' + index" v-model="preQualification.clientName"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'randDProjectsCompleted2Years' + index">Has the client completed their R&D projects within the last 2 financial years</label>
      </b-col>
      <b-col md="8">
        <b-form-radio-group :id="'randDProjectsCompleted2Years' + index" v-model="preQualification.randDProjectsCompleted2Years">
          <b-form-radio value="true">Yes</b-form-radio>
          <b-form-radio value="false">No</b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'previousClaim' + index">Have they previously claimed before</label>
      </b-col>
      <b-col md="8">
        <b-form-radio-group :id="'previousClaim' + index" v-model="preQualification.previousClaim">
          <b-form-radio value=true>Yes</b-form-radio>
          <b-form-radio value=false>No</b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>

    <!--Only show if yes selected above-->
    <b-row class="my-1" v-if="preQualification.previousClaim == 'true'">
      <b-col md="4" class="label">
        <label :for="'previousClaimWith' + index">Who did they claim with</label>
      </b-col>
      <b-col md="8">
        <b-form-textarea :id="'previousClaimWith' + index" v-model="preQualification.previousClaimWith"></b-form-textarea>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'advancementSector' + index">What sector is the advancement in?</label>
      </b-col>
      <b-col md="8">
        <b-form-group description="Please ensure you also fill out the sector tab.">
          <b-form-textarea :id="'advancementSector' + index" v-model="preQualification.advancementSector"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'historyScriptCompleted' + index">Have you completed the intro to Randd & scheme history script? </label>
      </b-col>
      <b-col md="8">
        <b-form-radio-group :id="'historyScriptCompleted' + index" v-model="preQualification.historyScriptCompleted">
          <b-form-radio value="true">Yes</b-form-radio>
          <b-form-radio value="false">No</b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'projectsSeekToAchieveScriptCompleted' + index">Have you completed the “Projects seek to achieve” script?</label>
      </b-col>
      <b-col md="8">
        <b-form-radio-group :id="'projectsSeekToAchieveScriptCompleted' + index" v-model="preQualification.projectsSeekToAchieveScriptCompleted">
          <b-form-radio value="true">Yes</b-form-radio>
          <b-form-radio value="false">No</b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'numberOfStaff' + index">How many staff does the business employ?</label>
      </b-col>
      <b-col md="8">
        <b-form-input :id="'numberOfStaff' + index"
                      type="number"
                      step="1"
                      v-model="preQualification.numberOfStaff">
        </b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'payrollCost' + index">Rough cost of payroll</label>
      </b-col>
      <b-col md="8">
        <b-form-input :id="'payrollCost' + index"
                      type="number"
                      step="1"
                      v-model="preQualification.payrollCost">
        </b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'randDSpend' + index">R&D spent</label>
      </b-col>
      <b-col md="8">
        <b-form-input :id="'randDSpend' + index"
                      type="number"
                      step="1"
                      v-model="preQualification.randDSpend">
        </b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'additionalNotes' + index">Additional notes</label>
      </b-col>
      <b-col md="8">
        <b-form-textarea :id="'additionalNotes' + index" v-model="preQualification.additionalNotes"></b-form-textarea>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'callTypeId' + index">Call Type</label>
      </b-col>
      <b-col md="8">
        <b-form-select :id="'callTypeId' + index"
                       :showClearButton='true'
                       :options="lookups.preQualificationCallTypes"
                       v-model="preQualification.callTypeId"
                       value-field="id"
                       text-field="name">
          <template v-slot:first>
            <b-form-select-option :value="null">-</b-form-select-option>
          </template>

        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'qualifierId' + index">Qualifier</label>
      </b-col>
      <b-col md="8">
        <b-form-select :id="'qualifierId' + index"
                       :showClearButton='true'
                       :options="lookups.qualifiers"
                       v-model="preQualification.qualifierId"
                       value-field="id"
                       text-field="fullName">
          <template v-slot:first>
            <b-form-select-option :value="null">-</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="3">

      </b-col>
      <b-col md="9">
        <b-button type="submit"
                  variant="success"
                  class="margin-right margin-sm-bottom"
                  @click="save"
                  :disabled="preQualification.submitted">
          <font-awesome-icon icon="save" /> Save
        </b-button>

        <b-button type="submit"
                  variant="success"
                  class="margin-right margin-sm-bottom"
                  @click="showCallbackModal"
                  :disabled="preQualification.submitted || !valid()"
                  >
          <font-awesome-icon icon="save" /> Submit
        </b-button>

      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3">
      </b-col>
      <b-col md="6">
        <Feedback ref="savePreQFeedback" />
      </b-col>
    </b-row>

    <CompanyPreQualificationCallbackModal v-if="lookups"
                           ref="preQualificationCallbackModal"
                            />

  </div>
</template>

<script>
  import CompanyService from '@/services/Company.service';
  import Feedback from "@/components/shared/Feedback.vue";
  import CompanyPreQualificationCallbackModal from "@/components/company/prequalification/CompanyPreQualificationCallbackModal.vue";
  export default {
    components: { Feedback, CompanyPreQualificationCallbackModal },
    props: {
      initialPreQualification: Object,
      lookups: Object,
      index: Number,
    },
    mounted() {
      if (this.initialPreQualification) {
        this.preQualification = { ...this.initialPreQualification };
      }
    },
    data() {
      return {
        preQualification: null
      }
    },
    methods: {
      save() {
        CompanyService.saveCompanyPreQualification(this.preQualification).then(() => {
          this.$refs.savePreQFeedback.showSuccess("Save Successful");
          this.$parent.$parent.$parent.$parent.$parent.loadData();  //:(
        });
      },
      //saveAndSubmit() {
      //  CompanyService.saveAndSubmitCompanyPreQualification(this.preQualification).then(() => {
      //    //TODO Modal for callback needed
      //    this.$refs.savePreQFeedback.showSuccess("Submit successful");
      //    this.$parent.$parent.$parent.$parent.$parent.loadData();  //:(
      //  });
      //},
      showCallbackModal() {
        this.$refs.preQualificationCallbackModal.showModal();
      },
      submitWithCallback(selectedDate, selectedTime, priority) {
        CompanyService.saveAndSubmitCompanyPreQualification(this.preQualification).then(() => {
          const callback = {
            companyId: this.preQualification.companyId,
            callbackUserId: this.preQualification.qualifierId,
            callbackDate: selectedDate,
            callbackTime: selectedTime,
            callbackPriorityId: priority
          };
          CompanyService.savePreQualificationCallback(callback).then(() => {
            this.$refs.savePreQFeedback.showSuccess("Submit successful");
            this.$parent.$parent.$parent.$parent.$parent.loadData();  //:(
          });
        });
      },
      valid() {
        if (!this.preQualification.companyId) return false;
        if (!this.preQualification.qualifierId) return false;
        return true;
      }
    }
  }
</script>

<style scoped>
  .label {
    text-align: right;
  }

  .label > label {
    margin-top: 6px;
  }
</style>
